export class PercentFieldParameter {
  absoluteHundred: number | undefined;
  suffix: string | undefined;
  moreThanHundred: boolean | undefined;
  lessThanNull: boolean | undefined;
  timeFormat: boolean | undefined;

  constructor() {
    this.moreThanHundred = false;
    this.lessThanNull = false;
  }
}
